<!--
  Mounts the guide card of a feature tour while a tour is on. Each layout has
  one host, because a tour can cross from the member app to a site page.
-->
<template>
  <FeatureTourLayer v-if="featureTour.tour" />
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted } from 'vue'
import { featureTour, loadFeatureTour } from './useFeatureTour'

const FeatureTourLayer = defineAsyncComponent(
  () => import('./FeatureTourLayer.vue'),
)

onMounted(loadFeatureTour)
</script>
